import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = `${config.backendUrl}/employeeGroup`;

export const fetchEmployeeGroups = createAsyncThunk(
  'employeeGroup/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API_URL);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createEmployeeGroups = createAsyncThunk(
  'employeeGroup/create',
  async (groupData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, groupData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateEmployeeGroup = createAsyncThunk(
  'employeeGroup/update',
  async ({ _id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/update/${_id}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteEmployeeGroup = createAsyncThunk(
  'employeeGroup/delete',
  async (_id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/delete/${_id}`);
      return _id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const employeeGroupSlice = createSlice({
  name: 'employeeGroup',
  initialState: {
    groups: [],
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearEmployeeGroupMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchEmployeeGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = action.payload;
      })
      .addCase(fetchEmployeeGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createEmployeeGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(createEmployeeGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        state.groups = [...state.groups, ...action.payload.created];
      })
      .addCase(createEmployeeGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || 'Creation failed';
      })

      .addCase(updateEmployeeGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmployeeGroup.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.groups.findIndex(g => g._id === action.payload._id);
        if (index !== -1) {
          state.groups[index] = action.payload;
        }
        state.successMessage = 'Updated successfully';
      })
      .addCase(updateEmployeeGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || 'Update failed';
      })

      .addCase(deleteEmployeeGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEmployeeGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = state.groups.filter(g => g._id !== action.payload);
        state.successMessage = 'Deleted successfully';
      })
      .addCase(deleteEmployeeGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || 'Delete failed';
      });
  },
});

export const { clearEmployeeGroupMessages } = employeeGroupSlice.actions;
export default employeeGroupSlice.reducer;
